import { useLazyQuery } from '@apollo/client'
import { Modal, Paper, Slide, Typography } from '@material-ui/core'
import WalletIcon from '@material-ui/icons/AccountBalanceWalletRounded'
import React, { useEffect } from 'react'

import { TRANSACTION_HISTORY_QUERY } from '../../../graphql/walletTransactions'
import { getDirection, getTranslate } from '../../../localization'
import { TransactionHistory } from '../../../types/walletTransaction'
import TransactionHistoryRow from './TransactionHistoryRow'
import { TransactionHistoryRowSkeleton } from './TransactionHistoryRow.skeleton'
import useStyles from './styles/index.styles'

interface TransactionHistoryModalProps {
  isOpen: boolean
  onClose: () => void
  transactionID: string
}

const TransactionHistoryModal: React.FC<TransactionHistoryModalProps> = ({
  isOpen,
  onClose,
  transactionID
}) => {
  const classes = useStyles()
  const [getTransactionHistory, { data, loading }] = useLazyQuery<{
    transactionHistory: TransactionHistory[]
  }>(TRANSACTION_HISTORY_QUERY)
  useEffect(() => {
    if (isOpen) {
      getTransactionHistory({
        variables: {
          transactionID: transactionID
        }
      })
    }
  }, [isOpen])

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <WalletIcon className={classes.CardMembershipIcon} color="primary" />
          <Typography variant="h3" className={classes.title} color="secondary">
            {getTranslate('Transaction History')}
          </Typography>
          <div className={classes.tableheader}>
            <div>
              <Typography variant="h4">{getTranslate('Date')}</Typography>
            </div>
            <div>
              <Typography variant="h4">
                {getTranslate('Payment Status')}
              </Typography>
            </div>
            <div>
              <Typography variant="h4">{getTranslate('Status')}</Typography>
            </div>
            <div />
          </div>
          {loading
            ? Array(3)
                .fill(null)
                .map((item, index) => (
                  <TransactionHistoryRowSkeleton key={index.toString()} />
                ))
            : data?.transactionHistory.map((history: TransactionHistory) => (
                <TransactionHistoryRow data={history} />
              ))}
        </Paper>
      </Slide>
    </Modal>
  )
}
export default TransactionHistoryModal
